import { MdEdit } from "react-icons/md"

import type { BoxProps } from "@chakra-ui/react"
import { Flex, IconButton } from "@chakra-ui/react"

export const EditableBox = ({ children, ...props }: BoxProps) => {
  return (
    <Flex
      justifyContent="space-between"
      align="center"
      _hover={{ bg: "rgba(42, 182, 115, 0.1)", cursor: "pointer" }}
      p={2}
      ml="0 !important"
      mb="0 !important"
      {...props}
    >
      {children}
      <IconButton
        colorScheme="primary"
        aria-label="Edit"
        size="sm"
        icon={<MdEdit />}
        ml={2}
      />
    </Flex>
  )
}
